import React from 'react';
import { InfoCard } from '@backstage/core-components';

type PremiumCardProps = {
  title: string;
  subheader?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
};

export const PremiumCard = ({
  title,
  subheader,
  action,
  children,
}: PremiumCardProps) => {
  return (
    <InfoCard title={title} subheader={subheader} action={action}>
      {children}
    </InfoCard>
  );
};
